import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./userDetailView.styl";
const template = require("./userDetailView.vue");

@Component({
  template: template
})
export class UserViewComponent extends Vue {


}

Vue.component("cmUserDetailView", UserViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/userDetailView/userDetailView.ts